import React from "react";
import styled from "styled-components"
import { EColor, ESize } from "../../styleConstants";
import { breakPoint, rem } from "../styleUtils";

const StepperWrapper = styled.div`
    display: flex;
    flex-direction: column;

    ${breakPoint('md')` 
        flex-direction: row;
    `}
`

const Content = styled.div`
    padding-top: ${rem(ESize.tiny)};
    margin-left: ${rem(ESize.small)};
    padding-bottom: ${rem(ESize.default)};

    ${breakPoint('md')` 
        padding-top: ${rem(ESize.small)};
        margin-left: 0px;   
        width: calc(100% - ${rem(ESize.default)});
    `}
`

const Number = styled.div`
    font-size: ${rem(18)};
    text-align: center;
    color: ${EColor.Russian};
    font-weight: 400;
    left: 0;
    right: 0;

    width: ${rem(ESize.medium)};
    max-width: ${rem(ESize.medium)};
    min-width: ${rem(ESize.medium)};

    height: ${rem(ESize.medium)};
    border-radius: ${rem(ESize.medium)};
    box-shadow: 0px 0px 0px ${rem(5)} ${EColor.Russian};

    padding: ${rem(6)};

    background: ${EColor.FloralWhite};
    z-index: 1;

    &::after {
        content: "";
        position: absolute;
        
        width: 2px;
        background: ${EColor.ColombianBlue};
        left: ${rem(ESize.medium / 2 - 1)};
        top: ${rem(ESize.medium + ESize.extra_small)};
        height: calc(100% - ${rem(ESize.medium + ESize.extra_small * 2)});

        ${breakPoint('md')` 
            top: ${rem(ESize.medium / 2 - 1)};
            left: ${rem(ESize.medium + ESize.extra_small)};
            height: 2px;
            width: calc(100% - ${rem(ESize.medium + ESize.extra_small * 2)});
        `}
        
    }
`

const StepContentWrapper = styled.div`
    flex: 1 1 0;
    position: relative;
    display: flex;
    ${breakPoint('md')` 
        flex-direction: column;
    `}

    //Dont connect last step with a line.

    &:last-child {
        ${Number}:after {
            content: none;
        }
    }
`

export default function Stepper ({
    children,
}: {
    children: JSX.Element[]
}) {
    return (
        <StepperWrapper>
            {children.map((content, index) => 
                <StepContentWrapper key={index}>
                    <Number>{index + 1}</Number>
                    <Content>
                        {content}
                    </Content>
                </StepContentWrapper>
            )}
        </StepperWrapper>
    )
}